/**
 * Camera options when previewing a stand above the mobile tag-out picker sheet.
 * Bottom padding lifts the stand into the visible map band above the sheet.
 */
export function buildPickerHighlightEaseOptions(coords, zoom, sheetHeightPx = 0) {
  const bottomPad = Math.max(Number(sheetHeightPx) + 40, 260);
  return {
    center: coords,
    zoom,
    duration: 450,
    padding: { top: 48, bottom: bottomPad, left: 24, right: 24 }
  };
}

export function clearMapPadding(map) {
  if (!map || typeof map.setPadding !== 'function') return;
  try {
    map.setPadding({ top: 0, bottom: 0, left: 0, right: 0 });
  } catch (_) {}
}
